// import React, { useState } from 'react';
// import AddCharge from '../AddEdit/AddCharge';
// import EditCharge from '../AddEdit/EditCharge';

// const ChargesTab = () => {
//     const [showAdd, setShowAdd] = useState(false);
//     const handleCloseAdd = () => setShowAdd(false);
//     const handleShowAdd = () => setShowAdd(true);

//     const [showEdit, setShowEdit] = useState(false);
//     const handleCloseEdit = () => setShowEdit(false);
//     const handleShowEdit = () => setShowEdit(true);

//     return (
//         <>
//             <div className="row border-bottom-2 pb-3">
//                 <div className="col-md-12">
//                     <div className="card px-3 py-2">
//                         <div className="row">
//                         <table className="table" style={{ borderCollapse: 'collapse' }}>
//     <thead>
//     <tr>
//     <th colSpan="2" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Particulars</th>
//     <th colSpan="4" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Revenue</th>
//     <th colSpan="4" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Cost</th>
// </tr>

//         <tr>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Charge Head</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Curr.</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount (INR)</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>P/C</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Curr.</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount (INR)</th>
//             <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>P/C</th>
//         </tr>
//     </thead>
//     <tbody>
//         <tr>
//             <td >Air Export Freight</td>
//             <td >INR</td>
//             <td >0.00</td>
//             <td >0.00</td>
//             <td >P</td>
//             <td >INR</td>
//             <td >0.00</td>
//             <td >0.00</td>
//             <td >P</td>
//         </tr>
//     </tbody>
// </table>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="py-2">
//                 <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
//                     <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
//                         New
//                     </button>
//                     <button className="btn btn-primary text-xs" type="button" onClick={handleShowEdit}>
//                         Edit
//                     </button>
//                     <button className="btn btn-primary text-xs" type="button">
//                         Delete
//                     </button>
//                 </div>
//             </div>

//             {showAdd && <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} />}
//             {showEdit && <EditCharge showEdit={showEdit} handleCloseEdit={handleCloseEdit} />}
//         </>
//     );
// };

// export default ChargesTab;

import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import Select from "react-select";

import { Code } from '@mui/icons-material';
const EntityTab = () => {

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);

useEffect(() => {
if (
showShipTo === true ||
showImporter === true ||
showBookingParty === true ||
showBuyer === true ||
showSeller === true ||
showTransporter === true
) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showShipTo, showImporter, showBookingParty, showBuyer, showSeller, showTransporter]);

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className=" py-2">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card d-flex flex-column p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red ">
                                    Consigner
                                </label>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Name
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                           
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Reg.Number
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                    Reg.Type
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>

                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Street
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Address
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   City
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  State/Sub Div
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   Country
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  Postal code
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>


                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="card d-flex flex-column p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red ">
                                    Consignee
                                </label>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Name
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                           
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Reg.Number
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                    Reg.Type
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>

                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Street
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Address
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   City
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  State/Sub Div
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   Country
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  Postal code
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>


                            </div>

                        </div>

                        <div className="col-md-6">
                            <div className="card d-flex flex-column p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red ">
                                    Notified Party
                                </label>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Name
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                           
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Reg.Number
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                    Reg.Type
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>

                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Street
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Address
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   City
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  State/Sub Div
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   Country
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  Postal code
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>


                            </div>

                        </div>

                        <div className="col-md-6">
                            <div className="card d-flex flex-column p-3 align-items-baseline">
                                <label htmlFor="DestinationAgent" className="form-label mx-2 text-label-red ">
                                    Consolidator
                                </label>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Name
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                           
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Reg.Number
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                    Reg.Type
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>

                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Street
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                    Address
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector ms-2 w-100"
                                        name="role_id" />



                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   City
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  State/Sub Div
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>
                                <div className="flex-grow-1 d-flex flex-row w-100">
                                <label htmlFor="DestinationAgent" className="form-label ">
                                   Country
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />
                                        <label htmlFor="DestinationAgent" className="form-label ms-2 ">
                                  Postal code
                                </label>
                                    <Select id="DestinationAgent" className="mt-2 custom-selector w-100"
                                        name="role_id" />

                                </div>


                            </div>

                        </div>
                       

                      
                    </div>
                    {/* <div className>
                        <label htmlFor="" className="form-label">Add/Remove Entity:</label>
                        <div className="row">
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Transporter" id="Transporter"
                                    onChange={(e)=> setShowTransporter(e.target.checked)} />
                                <label htmlFor="Transporter" className="form-label">Transporter</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Ship to" id="Ship to" onChange={(e)=>
                                setShowShipTo(e.target.checked)} />
                                <label htmlFor="Ship to" className="form-label">Ship to</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Booking Party" id="Booking Party"
                                    onChange={(e)=> setShowBookingParty(e.target.checked)} />
                                <label htmlFor="Booking Party" className="form-label">Booking Party</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Seller" id="Seller" onChange={(e)=>
                                setShowSeller(e.target.checked)} />
                                <label htmlFor="Seller" className="form-label">Seller</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Importer" id="Importer" onChange={(e)=>
                                setShowImporter(e.target.checked)} />
                                <label htmlFor="Importer" className="form-label">Importer</label>
                            </div>
                            <div className="col-md-2">
                                <input type="checkbox" className="mx-2" name="Buyer" id="Buyer" onChange={(e)=>
                                setShowBuyer(e.target.checked)} />
                                <label htmlFor="Buyer" className="form-label">Buyer</label>
                            </div>
                        </div>
                    </div> */}
{/* 
                    {showExtraEntity && (
                    <div className="row">
                        {showTransporter && (
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="Transporter"
                                    className="form-label mx-2 ">Transporter:</label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="Transporter" className="mt-2 custom-selector w-100" name="role_id" />
                                </div>
                            </div>
                        </div>
                        )}
                        {showShipTo && (
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="ShipTo" className="form-label mx-2 ">Ship to:</label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="ShipTo" className="mt-2 custom-selector w-100" name="role_id" />
                                </div>
                            </div>
                        </div>
                        )}
                        {showBookingParty && (
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="BookingParty" className="form-label mx-2 ">Booking
                                    Party:</label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="BookingParty" className="mt-2 custom-selector w-100" name="role_id" />
                                </div>
                            </div>
                        </div>
                        )}
                        {showSeller && (
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="Seller" className="form-label mx-2 ">Seller:</label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="Seller" className="mt-2 custom-selector w-100" name="role_id" />
                                </div>
                            </div>
                        </div>
                        )}
                        {showImporter && (
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="Importer" className="form-label mx-2 ">Importer:</label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="Importer" className="mt-2 custom-selector w-100" name="role_id" />
                                </div>
                            </div>
                        </div>
                        )}
                        {showBuyer && (
                        <div className="col-md-6">
                            <div className="card d-flex flex-row p-3 align-items-baseline">
                                <label htmlFor="Buyer" className="form-label mx-2 ">Buyer:</label>
                                <div className="flex-grow-1 d-flex flex-column">
                                    <Select id="Buyer" className="mt-2 custom-selector w-100" name="role_id" />
                                </div>
                            </div>
                        </div>
                        )}
                    </div>
                    )} */}

                </div>
            </div>
        </div>
       
    </form>
</>
)
}

export default EntityTab
